import { render } from "./DropdownCompany.vue?vue&type=template&id=57a46ada"
import script from "./DropdownCompany.vue?vue&type=script&lang=ts"
export * from "./DropdownCompany.vue?vue&type=script&lang=ts"
script.render = render

export default script